export default "__VITE_ASSET__CBPK66Y7__"